import * as yup from "yup";
import i18n from "../../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const min5LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 5});
const min6LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 6});
const max255LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 255});
const max500LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 500});
const phoneFormatMessage = () => i18n.t("validation.phoneFormat", {ns: "common"});
const emailFormatMessage = () => i18n.t("validation.emailFormat", {ns: "common"});
const tcknFormatMessage = () => i18n.t("validation.tcknFormat", {ns: "common"});
const ibanFormatMessage = () => i18n.t("validation.ibanFormat", {ns: "common"});

export const newCourierValidation = yup.object().shape({
    fullname: yup
        .string()
        .min(6, min6LengthsMessage)
        .max(255, max255LengthsMessage)
        .required(requiredMessage),
    type: yup.string().required(requiredMessage),
    // regions: yup.array().required(requiredMessage),
    cellPhone: yup
        .string()
        .matches(/^0(\(([0-9]{3}\)-[0-9]{3}-[0-9]{4}))|([0-9]{10}$)/, phoneFormatMessage)
        .required(requiredMessage),
    email: yup
        .string()
        .email(emailFormatMessage)
        .required(requiredMessage),
    birthDate: yup.date().required(requiredMessage),
    tckn: yup
        .string()
        .matches(/^[1-9]{1}[0-9]{9}[2,4,6,8,0]{1}$/, tcknFormatMessage)
        .required(requiredMessage),
    bloodGroup: yup.string(),
    address: yup
        .string()
        .min(5, min5LengthsMessage)
        .max(500, max500LengthsMessage)
        .required(requiredMessage),
    vehicleInfo: yup.string().required(requiredMessage),
    emergencyContactName: yup
        .string()
        .min(6, min6LengthsMessage)
        .max(255, max255LengthsMessage)
        .required(requiredMessage),
    emergencyContactPhone: yup
        .string()
        .matches(/^0(\(([0-9]{3}\)-[0-9]{3}-[0-9]{4}))|([0-9]{10}$)/, phoneFormatMessage)
        .required(requiredMessage),
    emergencyContactDegree: yup.string().required(requiredMessage),
    city: yup.string().required(requiredMessage),
    county: yup.string().required(requiredMessage),
    bankName: yup.string().required(requiredMessage),
    iban: yup
        .string()
        .matches(/^TR[0-9]{24}$/, ibanFormatMessage)
        .required(requiredMessage),
    photo: yup.mixed(),
    gender: yup.string().required(requiredMessage),
    homeLocation: yup.object().shape({
        longitude: yup.number().required(requiredMessage),
        latitude: yup.number().required(requiredMessage)
    })
});
